export default "__VITE_ASSET__Bii3qGoq__"